import { profileRoutes } from './profile.routing'
import { ProfileComponent } from './profile.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { I18nModule } from '@containers/i18n/i18n.module'
import { SharedModule } from '@shared/shared.module'

@NgModule({
  declarations: [ProfileComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(profileRoutes, {
      scrollPositionRestoration: 'top',
    }),
    I18nModule,
    HttpClientModule,
    SharedModule,
  ],
  exports: [ProfileComponent],
})
export class ProfileModule {}
